import { UserImportedRankingEntry } from 'models/ranking/importedRanking/entry/UserImportedRankingEntry';

export class UserImportedRankingEntryService {
	toModel(ranking) {
		return new UserImportedRankingEntry(ranking);
	}
}
